import React from 'react'
import {
  Card,
  Flex,
  Title,
  Button,
  StyledTable,
  TableHeader,
  TableHeaderLabel,
  TableBody,
  NameCell,
  DesignationCell,
  EmailCell,
  ContactNoCell,
  ContactActionsCell,
  ContactActions,
} from '../../components/StyledComponents'
import { UserContact } from './types'
import { DeleteIcon, EditBlackIcon, PlusIcon, PrimaryContactTag } from './icons'

interface Props {
  contacts: UserContact[]
  onAddContact: () => void
  onEditContact: (c: UserContact) => void
  onDeleteContact: (c: UserContact) => void
}

export const ContactsSection: React.FC<Props> = ({ contacts, onAddContact, onEditContact, onDeleteContact }) => {
  return (
    <Card>
      <Flex>
        <Title>Contacts</Title>
        <Button onClick={onAddContact}>
          <PlusIcon /> Add New Contact
        </Button>
      </Flex>

      <StyledTable>
        <TableHeader>
          <tr>
            <TableHeaderLabel>Name</TableHeaderLabel>
            <TableHeaderLabel>Designation</TableHeaderLabel>
            <TableHeaderLabel>Email</TableHeaderLabel>
            <TableHeaderLabel>Contact no.</TableHeaderLabel>
            <TableHeaderLabel>Action</TableHeaderLabel>
          </tr>
        </TableHeader>

        <TableBody>
          {contacts.filter(c => c.contact?.contact_type != "company").map((c) => (
            <tr key={c.contact_id}>
              <NameCell>
                  {c.contact?.first_name ?? '-'}
                  {c.contact?.contact_type === 'primary' && <PrimaryContactTag />}
              </NameCell>
              <DesignationCell>{c.contact?.position ?? '-'}</DesignationCell>
              <EmailCell>{c.contact?.email_id ?? '-'}</EmailCell>
              <ContactNoCell>{c.contact?.mobile_phone ?? '-'}</ContactNoCell>
              <ContactActionsCell>
                <ContactActions onClick={() => onEditContact(c)} style={{ cursor: 'pointer' }} aria-label={`edit-${c.contact_id}`}>
                  <EditBlackIcon />
                </ContactActions>

                {c.contact?.contact_type !== 'primary' && (<ContactActions onClick={() => onDeleteContact(c)} style={{ cursor: 'pointer' }} aria-label={`delete-${c.contact_id}`}>
                  <DeleteIcon />
                </ContactActions>)}
              </ContactActionsCell>
            </tr>
          ))}
        </TableBody>
      </StyledTable>
    </Card>
  )
}